// eslint-disable-next-line no-unused-vars
import * as React from 'react';
import { simpleTag } from '../Base';

export const LineRipple = simpleTag({
  displayName: 'LineRipple',
  classNames: 'mdc-line-ripple'
});

export default LineRipple;



// WEBPACK FOOTER //
// ./src/LineRipple/index.js